<template>
  <b-badge v-if="!!value" :variant="variant">
    {{ text }}
  </b-badge>
</template>

<script>
  export default {
    props: {
      value: String,
      adminName: String,
    },
    data() {
      return {
        trans: trans,
      }
    },
    computed: {
      variant() {
        if (!!this.value && this.value.indexOf('::') >= 0) {
          return this.value.split('::')[0] || 'secondary'
        }
        switch(this.value) {
          case 'class':
          case 'draft':
            return 'secondary'
          case 'new':
          case 'lent_out':
          case 'sent':
            return 'primary'
          case 'cart':
            return 'info'
          case 'absent':
          case 'not_paid':
          case 'interac_pending':
          case 'other_payment_method_pending':
          case 'debit_payment_method_pending':
          case 'cancelled':
          case 'admin-deleted':
          case 'has_balance':
          case 'cart-removed':
          case 'cart-expired':
          case 'in_stock':
          case 'membership_pending':
          case 'suspended':
          case 'inactive_not_paid':
            return 'danger'
          case 'signed':
          case 'present':
          case 'paid':
          case 'deposit_paid':
          case 'picked_up':
          case 'returned':
          case 'credit':
          case 'admin-restored':
          case 'active':
            return 'success'
        }
        return 'secondary'
      },
      text() {
        if (!!this.value && this.value.indexOf('::') >= 0) {
          return this.value.split('::')[1] || ' ? '
        }
        switch(this.value) {
          case 'new':
            if (!!this.adminName) return this.adminName
            return trans('admin')
          case 'cart':
            return trans('in_cart')
          case 'cart-removed':
          case 'cart-expired':
            return trans('booking_filter_type_expired')
          case 'class':
          case 'absent':
          case 'present':
          case 'not_paid':
          case 'interac_pending':
          case 'other_payment_method_pending':
          case 'debit_payment_method_pending':
          case 'cancelled':
          case 'admin-deleted':
          case 'admin-restored':
          case 'deposit_paid':
          case 'has_balance':
          case 'paid':
          case 'in_stock':
          case 'lent_out':
          case 'picked_up':
          case 'returned':
          case 'credit':
          case 'draft':
          case 'sent':
          case 'signed':
          case 'membership_pending':
          case 'suspended':
          case 'active':
          case 'inactive_not_paid':
            return trans(this.value)
        }
        return '  ?  '
      },
    },
  }
</script>